<div class="row nopadding">
  <div class="panel panel-default nopadding">
    <div class=" panel-title">
      System Log
      <i (click)="loadSummaryLogData()" title="Refresh" class="fa fa-refresh align-right" aria-hidden="true"></i>
      &nbsp;
    </div>
    <div class="panel-body nopadding " style="max-height:520px !important;overflow-y: auto !important;">
      @if(isLoadingResults){
      <div class="example-loading-shade">
        @if(isLoadingResults){
        <mat-spinner>Loading...</mat-spinner>
        }
        @if(isRateLimitReached){
        <div class="example-rate-limit-reached">
          API rate limit has been reached. It will be reset in one minute.
        </div>
        }
      </div>
      }
      <table mat-table class="highlight" #table [dataSource]="dataSource" matSort matSortActive="time" matSortDisableClear>
        @for(col of displayedColumns; track col; let i = $index){
        <ng-container matColumnDef={{col}}>
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-weight: bold;">{{col==='time' ? 'Time':
            'Event Description'}} </th>
          <td mat-cell *matCellDef="let DATA; let j ; let m = index">
            @if(m==0 && DATA[col]==firstNumber){
            <span class="glyphicon glyphicon-chevron-right blink">
            </span>
            }
            {{DATA[col]}}
          </td>
        </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator #paginator 
        style="position:relative; bottom: 0;"
        [pageSize]="rowcount"
        [pageSizeOptions]="[1,2,3,4,5,10,20,50,100]"
        showFirstLastButtons
        aria-label="Select page of periodic elements">
      </mat-paginator>
    </div>
  </div>
</div>